export type InvestmentProductType = 'cdb' | 'rdb'

const PRODUCT_TYPE_BY_VALUE: Record<string, InvestmentProductType> = {
  cdb: 'cdb',
  rdb: 'rdb'
}

export function resolveInvestmentProductType(type?: string): InvestmentProductType {
  return PRODUCT_TYPE_BY_VALUE[type?.toLowerCase() ?? ''] ?? 'cdb'
}
